import { getHelpTopicPath } from "@/help/routes";
import { getHelpTopicTrail, HELP_TOPICS } from "@/help/topics";
import type { IAiScriptExplanationChatSource } from "@/payroll/ai-script/types";
import type { ChatMessageSource } from "./types";

const getServiceTitanLink = (
  source: IAiScriptExplanationChatSource,
): ChatMessageSource["serviceTitanLink"] => {
  if (source.invoice_id) {
    return {
      url: `/#/EditInvoice/${source.invoice_id}`,
      label: `Open invoice ${source.invoice_id} in ServiceTitan`,
    };
  }
  if (source.job_id) {
    return {
      url: `/#/Job/Index/${source.job_id}`,
      label: `Open job ${source.job_id} in ServiceTitan`,
    };
  }
  return null;
};

export const enrichMessageSource = (
  source: IAiScriptExplanationChatSource,
  index: number,
): ChatMessageSource => {
  const title = source.label ?? source.title ?? source.type ?? "Source";
  const helpTopic =
    source.type === "help" && source.help_topic_id
      ? getHelpTopicTrail(HELP_TOPICS, source.help_topic_id).at(-1)
      : undefined;

  return {
    key: source.id ?? `${title}-${index}`,
    title,
    detail: source.detail ?? source.description ?? null,
    serviceTitanLink: getServiceTitanLink(source),
    helpPath:
      helpTopic && !helpTopic.isSection ? getHelpTopicPath(helpTopic.id) : null,
  };
};
